import React from 'react';
import './ImagePreview.css';

interface Props {
  src?: string;
  width?: number | string;
  height?: number | string;
}

export default function ImagePreview({ src, width, height }: Props): JSX.Element | null {
  if (!src) {
    return null;
  }

  return (
    <a href={src} target="_blank" rel="noopener noreferrer" className="image-preview__wrapper">
      <img
        style={{
          width,
          height,
        }}
        className="image-preview"
        src={src}
      />
    </a>
  );
}
